import { render, staticRenderFns } from "./project-custom-field-register.component.vue?vue&type=template&id=a4b9f9d2&scoped=true&"
import script from "./project-custom-field-register.component.vue?vue&type=script&lang=ts&"
export * from "./project-custom-field-register.component.vue?vue&type=script&lang=ts&"
import style0 from "./project-custom-field-register.component.vue?vue&type=style&index=0&id=a4b9f9d2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b9f9d2",
  null
  
)

export default component.exports